import React from "react";
import SurveyForm from "./surveyForm";

class SurveyFormParent extends React.Component {
    render() {
        return <SurveyForm />;
    }
}
export default SurveyFormParent;
